import React from 'react';
import {Redirect} from 'react-router';

import paths from '@/config/paths';

export const MatchPathRedirect: React.FC = () => {
  return <Redirect to={paths.signIn.main} />;
};
